module.exports = __webpack_public_path__ + "static/media/group_variant_ICON.1159a20b.svg";